import React from 'react';
import { Box, createStyles, useMantineTheme } from '@mantine/core';
import Image from 'next/image';

import dt from '~/testing';

type PageHeaderBannerProps = {
  src: string;
  isSidePanel?: boolean;
};

const useStyles = createStyles({
  root: {
    width: '100%',
    objectFit: 'cover',
  },
});

export function PageHeaderBanner({ src, isSidePanel }: PageHeaderBannerProps) {
  const theme = useMantineTheme();
  const { classes } = useStyles();

  return (
    <Box h={isSidePanel ? 60 : 170} pos="relative">
      <Image
        fill
        data-test-id={dt.contestDetail.page.header.banner}
        className={classes.root}
        alt="backdrop"
        src={src}
        priority
        sizes={`${theme.breakpoints.xl * 2}px`}
        quality={100}
      />
    </Box>
  );
}
